import { useEffect } from "react";
import { useNavigation } from "@react-navigation/core";

export function useOnBeforeLeaveScreen(fun: () => any) {
  const navigation = useNavigation();
  useEffect(() => {
    const unsubscribe = navigation.addListener("beforeRemove", fun);

    return unsubscribe;
  }, [fun, navigation]);
}
